var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "pa-0 py-2",
      staticStyle: { "min-height": "calc(100% - 36px)" },
      attrs: { fluid: "" },
    },
    [
      _vm.shiftData.length == 0 ? _c("noContent") : _vm._e(),
      _vm._l(_vm.shiftData, function (item, index) {
        return _c(
          "v-sheet",
          {
            key: "myshift--" + index,
            staticClass: "d-flex justify-start flex-column py-2",
            attrs: { width: "100%", height: "auto" },
          },
          [
            _c(
              "v-sheet",
              { staticClass: "px-2 d-flex justify-start flex-row" },
              [
                _c(
                  "v-sheet",
                  {
                    attrs: {
                      width: "40",
                      height: "auto",
                      color: "transparent",
                    },
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticStyle: { background: "#ffdec0" },
                        attrs: { ripple: false, icon: "" },
                      },
                      [
                        _c("svg-icon", {
                          attrs: {
                            size: "20",
                            fill: "rgba(0,0,0,0.87)",
                            iconClass: "punch",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-container",
                  {
                    staticClass: "pa-0 ml-1 text-left mr-12",
                    attrs: { fluid: "" },
                  },
                  [
                    item && !item.is_master
                      ? _c(
                          "v-chip",
                          {
                            staticClass: "py-2 px-0 pr-2",
                            staticStyle: { height: "36px" },
                            attrs: { pill: "" },
                          },
                          [
                            _c("StaffAvatar", {
                              attrs: {
                                size: "30",
                                src: item["staff_avatar"],
                                staff_name: _vm.$getCommonLangValue(
                                  item.preferred_name
                                ),
                              },
                            }),
                            _c("span", { staticClass: "text-body-2 ml-1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$getCommonLangValue(item.preferred_name)
                                )
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-sheet",
                      { staticClass: "px-1 text-subtitle-2 my-2" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(
                                item["official_shift_abbr"]
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    item.site_uuid
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "d-flex justify-start align-center my-2",
                          },
                          [
                            _c("svg-icon", {
                              attrs: {
                                size: "20",
                                fill: "rgba(0,0,0,0.54)",
                                iconClass: "site",
                                className: "flex-shrink-1",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mx-2 text--secondary text-ellipsis-2",
                                staticStyle: { width: "calc(100% - 20px)" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(item.site_name)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-sheet",
                      { staticClass: "d-flex justify-start align-center my-2" },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons-round md-20",
                            staticStyle: { color: "rgba(0, 0, 0, 0.54)" },
                          },
                          [_vm._v("access_time")]
                        ),
                        _c(
                          "v-sheet",
                          {
                            staticClass:
                              "\n              rounded\n              justify-center\n              d-flex\n              align-center\n              mx-2\n              px-2\n              text-h5\n            ",
                            class: item["actual_punch_in_uuid"]
                              ? "grey lighten-3 text--primary  "
                              : " mrc-border-solid   text--secondary",
                            attrs: { width: "100", height: "30" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item["actual_punch_in_uuid"]
                                    ? item["official_punch_in_utc_datetime"]
                                    : item["official_start_utc_time"],
                                  "HH:mm"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(" - ")]),
                        _c(
                          "v-sheet",
                          {
                            staticClass:
                              "\n              rounded\n              px-2\n              mx-2\n              justify-center\n              d-flex\n              align-center\n              text-h5\n            ",
                            class: item["actual_punch_out_uuid"]
                              ? "grey lighten-3 text--primary "
                              : " mrc-border-solid  text--secondary",
                            attrs: { width: "100", height: "30" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item["actual_punch_out_uuid"]
                                    ? item["official_punch_out_utc_datetime"]
                                    : item["official_end_utc_time"],
                                  "HH:mm"
                                )
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    item.leave_type_remark_uuid
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "d-flex justify-start align-center my-2",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "material-icons-round md-20 flex-shrink-1",
                                staticStyle: { color: "rgba(0, 0, 0, 0.54)" },
                              },
                              [_vm._v("event")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mx-2 text--secondary text-ellipsis-2",
                                staticStyle: { width: "calc(100% - 20px)" },
                                attrs: {
                                  title: _vm.$getCommonLangValue(
                                    item.leave_type_remark_name
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        item.leave_type_remark_name
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    item.remarks
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "d-flex justify-start align-start my-2 flex-row",
                          },
                          [
                            _c("svg-icon", {
                              attrs: {
                                className: "flex-shrink-1 flex-grow-1",
                                size: "20",
                                fill: "rgba(0, 0, 0, 0.54)",
                                iconClass: "mini_doc",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mx-2 text--secondary text-ellipsis-2",
                                staticStyle: { width: "calc(100% - 20px)" },
                                attrs: {
                                  title: _vm.$getCommonLangValue(item.remarks),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(item.remarks)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    item
                      ? _c(
                          "v-sheet",
                          { staticClass: "px-1 my-2" },
                          [
                            Number(item.is_late)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 white--text",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_late_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_lateLabel"
                                        )
                                      ) +
                                        "(" +
                                        _vm._s(
                                          item.official_total_late_minutes || 0
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_minutesLabel"
                                          )
                                        ) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_ot)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 white--text",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_ot_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_otLabel"
                                        )
                                      ) +
                                        "(" +
                                        _vm._s(
                                          item.official_total_ot_minutes || 0
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_minutesLabel"
                                          )
                                        ) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_early_leave)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 white--text",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_early_leave_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_earlyLeaveLabel"
                                        )
                                      ) +
                                        "(" +
                                        _vm._s(
                                          item.official_total_early_leave_minutes ||
                                            0
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_minutesLabel"
                                          )
                                        ) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_absense)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 white--text",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_absense_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_absenseLabel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_work_from_home)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 text--primary",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_work_from_home_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_punchRecord_list_tag_workFromHomeLabbel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_locked)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 white--text",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_locked_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_isLockedLabel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_adhoc)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 text--primary",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_adhoc_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_isAdhocLabel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_missing_punch)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 white--text",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_missing_punch_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_isMissingPunchLabel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_out_of_office)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 text--primary",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_out_of_office_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_isOutOfOfficeLabel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            Number(item.is_onDuty)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-1 white--text",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_on_duty_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_tag_label_isOnDutyLabel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._l(item.leave_info, function (leave, index) {
                              return _c(
                                "v-chip",
                                {
                                  key: "leave--" + index,
                                  staticClass: "ma-1",
                                  attrs: {
                                    small: "",
                                    color: leave.color_code,
                                    outlined: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        leave["leave_type_name"]
                                      )
                                    )
                                  ),
                                ]
                              )
                            }),
                            _vm._l(
                              item.holiday_info,
                              function (holiday, index) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: "holiday--" + index,
                                    staticClass: "ma-1 text--primary",
                                    attrs: {
                                      small: "",
                                      color: _vm.$getTagColors(
                                        _vm.$card_line_colors,
                                        "is_holiday_1"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          holiday["holiday_name"]
                                        )
                                      )
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    item && !item.is_master
                      ? _c("v-divider", { staticClass: "mt-3" })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            item && item.is_master
              ? _c("v-divider", { staticClass: "mt-3" })
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }